import { apiSlice } from "./apiSlice";
import API_CONFIG from '../config/api';

export const userApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        login: builder.mutation({
            query: (data) => ({
                url: API_CONFIG.ENDPOINTS.USER.AUTH,
                method: 'POST',
                body: data,
            }),
        }),

        register: builder.mutation({
            query: (data) => ({
                url: API_CONFIG.ENDPOINTS.USER.REGISTER,
                method: 'POST',
                body: data,
            }),
        }),

        forgotPassword: builder.mutation({
            query: (data) => ({
                url: API_CONFIG.ENDPOINTS.USER.FORGOT_PASSWORD,
                method: 'POST',
                body: data,
            }),
        }),

        resetPassword: builder.mutation({
            query: (data) => ({
                url: API_CONFIG.ENDPOINTS.USER.RESET_PASSWORD,
                method: 'POST',
                body: data,
            }),
        }),

        resendVerification: builder.mutation({
            query: (data) => ({
                url: API_CONFIG.ENDPOINTS.USER.RESEND_VERIFICATION,
                method: 'POST',
                body: data,
            }),
        }),

        logout: builder.mutation({
            query: () => ({
                url: API_CONFIG.ENDPOINTS.USER.LOGOUT,
                method: 'POST',
            }),
        }),

        updateUser: builder.mutation({
            query: (data) => ({
                url: API_CONFIG.ENDPOINTS.USER.UPDATE_PROFILE,
                method: 'PUT',
                body: data,
            }),
        }),
        getSiteTheme: builder.query({
            query: () => ({
                url: API_CONFIG.ENDPOINTS.USER.SITE_THEME,
                method: 'GET',
            }),
            providesTags: ['SiteTheme'],
        }),
        getSystemSettings: builder.query({
            query: () => ({
                url: API_CONFIG.ENDPOINTS.USER.SYSTEM_SETTINGS,
                method: 'GET',
            }),
            providesTags: ['SystemSettings'],
        }),
        updateSystemSettings: builder.mutation({
            query: (data) => ({
                url: API_CONFIG.ENDPOINTS.USER.SYSTEM_SETTINGS,
                method: 'PUT',
                body: data,
            }),
            invalidatesTags: ['SiteTheme', 'SystemSettings'],
        }),

        // getUserProfile: builder.query({
        //     query: () => ({
        //         url: `${USERS_URL}/profile`, // Endpoint to fetch user profile
        //         method: "GET",
        //         headers: {
        //             Authorization: `Bearer ${localStorage.getItem("token")}`, 
        //           },
        //     }),
        // }),

        assignRole: builder.mutation({
            query: (data) => ({
              url: API_CONFIG.ENDPOINTS.USER.ASSIGN_ROLE,
              method: "POST",
              body: data,
            }),
            invalidatesTags: ["User"], // Invalidate cache if needed
          }),


        getAllRestaurants: builder.query({
            query: () => ({
                url: API_CONFIG.ENDPOINTS.USER.GET_ALL_RESTAURANTS,
                method: 'GET',
            }),
          }),

        getAllRestaurantsPagi: builder.query({
            query: ({ page = 1, limit = 5 }) => ({
              url: `${API_CONFIG.ENDPOINTS.USER.GET_ALL_RESTAURANTS_PAGI}?page=${page}&limit=${limit}`,
              method: "GET",
            }),
          }),

          getrestaurantById: builder.query({
            query: (id) => ({
                url: `${API_CONFIG.ENDPOINTS.USER.GET_RESTAURANT_BY_ID}/${id}`,
                method: 'GET',
            }),
        }),

        searchRestaurants: builder.query({
            query: ({ localisation, diet, minBill, maxBill }) =>
              `${API_CONFIG.ENDPOINTS.USER.SEARCH_RESTAURANTS}?localisation=${localisation}&diet=${diet}&minBill=${minBill}&maxBill=${maxBill}`,
          }),

        filterRestaurants: builder.query({
            query: (filters) => {
              const queryParams = new URLSearchParams(filters).toString();
              return `${API_CONFIG.ENDPOINTS.USER.FILTERED_RESTAURANTS}?${queryParams}`;
            },
          }),

          getCountries: builder.query({
            query: () => ({
                url: API_CONFIG.ENDPOINTS.USER.COUNTRIES,
                method: 'GET',
            }),
          }),

          getDiet: builder.query({
            query: () => ({
                url: API_CONFIG.ENDPOINTS.USER.DIETS,
                method: 'GET',
            }),
          }),

    }),
});

export const {
    useLoginMutation,
    useLogoutMutation,
    useRegisterMutation,
    useForgotPasswordMutation,
    useResetPasswordMutation,
    useResendVerificationMutation,
    useUpdateUserMutation,
    useGetSiteThemeQuery,
    useGetSystemSettingsQuery,
    useUpdateSystemSettingsMutation,
    useGetAllRestaurantsQuery,
    useGetAllRestaurantsPagiQuery,
    useGetrestaurantByIdQuery,
    useSearchRestaurantsQuery,
    useFilterRestaurantsQuery,
    useGetCountriesQuery,
    useGetDietQuery,
 } = userApiSlice;